import { HttpErrorResponse } from '@angular/common/http';

/** The Banku API sometimes returns a validation map instead of a single message. */
interface ApiErrorBody {
  err?: boolean;
  message?: string;
  errors?: Record<string, string>;
  type?: string;
}

/** Extracts a human-readable message from an API error, whether it came as an HTTP error or an inline `err: true` body. */
export function extractApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof HttpErrorResponse) {
    if (err.status === 0) {
      return 'No se pudo conectar con el servidor. Revisa tu conexión a internet.';
    }
    const body = err.error as ApiErrorBody | string | null;
    if (body && typeof body === 'object') {
      const message = firstErrorMessage(body);
      if (message) return message;
    }
  } else if (err && typeof err === 'object') {
    const message = firstErrorMessage(err as ApiErrorBody);
    if (message) return message;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}

function firstErrorMessage(body: ApiErrorBody): string | null {
  if (body.errors && typeof body.errors === 'object') {
    const first = Object.values(body.errors)[0];
    if (typeof first === 'string') return first;
  }
  if (typeof body.message === 'string') return body.message;
  return null;
}

/** Some protected endpoints reply with HTTP 200 and `{ err: true }` (session expired) instead of a real HTTP error. */
export function isApiErrorBody(body: unknown): body is ApiErrorBody {
  return !!body && typeof body === 'object' && (body as ApiErrorBody).err === true;
}
